export default "__VITE_ASSET__C7df3J9x__"